import {createSlice} from '@reduxjs/toolkit';

const initialState = {
   order: localStorage.getItem('order') ?
     JSON.parse(localStorage.getItem('order')) : null,
};

const orderSlice = createSlice({
   name:'order',
   initialState,
   reducers: {
       createOrder: (state, action) => {
           state.order =action.payload;
           localStorage.setItem('order',
           JSON.stringify(action.payload));
       },
       clearOrder: (state) => {
        state.order = null;
        localStorage.removeItem('order');
       }
   }
}); 

export const {createOrder, clearOrder} = orderSlice.actions; 

export default orderSlice.reducer;